
import Vue from "vue";

export default Vue.extend({
  name: "ThreeDotIcon",
  props: {
    color: {
      type: String,
      default: "currentColor",
    },
    width: {
      type: String,
      default: "4",
    },
    height: {
      type: String,
      default: "14",
    },
  },
});
